export const CUSTOMERS = {
    CalGiant: 8,
};
